import './style.scss';
import React, { FC } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Image404 from "../../assets/img/404 Error-rafiki.png";

const NotFound: FC = () => {
    const navigate = useNavigate();

    return (
        <motion.div
            className="NotFound"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <motion.div className="center" initial={{ scale: 0.9 }} animate={{ scale: 1 }}>
                <motion.img
                    src={Image404}
                    width={400}
                    alt="404 Not Found"
                    className="notfound-illustration"
                    whileHover={{ scale: 1.03 }}
                />
                <p>
                    Aucune page trouvée. Veuillez retourner à l’accueil ou vérifier si votre session est toujours
                    active.
                </p>
                <motion.button
                    className="back-button"
                    onClick={() => navigate("/")}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Retour à l'accueil
                </motion.button>
            </motion.div>
        </motion.div>
    );
};

export default NotFound;
